var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubemusicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1328_1393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7891 4.43827C18.3391 4.43827 22.0618 8.1413 22.0618 12.711C22.0618 17.2807 18.3588 20.9837 13.7891 20.9837C9.21942 20.9837 5.51639 17.2807 5.51639 12.711C5.51639 8.1413 9.23912 4.43827 13.7891 4.43827ZM13.7891 3.65039C8.78609 3.65039 4.72852 7.70797 4.72852 12.711C4.72852 17.714 8.78609 21.7716 13.7891 21.7716C18.7922 21.7716 22.8497 17.714 22.8497 12.711C22.8497 7.70797 18.7922 3.65039 13.7891 3.65039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6377 17.2415L18.3195 12.5142L10.6377 8.18091V17.2415Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1328_1393"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubemusicIcon);
export default __webpack_public_path__ + "static/media/youtubemusic_icon.bb92350bab722bb8c8a50d0cfaf8acc0.svg";
export { ForwardRef as ReactComponent };